import type { SurveyAnswerRecord, SurveyConfig } from '../../types'

export type FileOption = {
  name: string
  type: string
  content: string
}

export function extractImageUrls(surveyConfigJson: SurveyConfig, surveyAnswer: SurveyAnswerRecord): string[] {
  const imageUrls: string[] = []

  try {
    surveyConfigJson.elements?.forEach((element) => {
      const { type, name } = element

      // 画像選択
      if (type === 'imagepicker') {
        const choices = (element).choices
        const selectedValue = surveyAnswer[name]
        if (selectedValue) {
          const selectedValues = Array.isArray(selectedValue) ? selectedValue : [selectedValue]
          selectedValues.forEach((value) => {
            const choice = choices?.find(choice => choice.value === value)
            if (choice?.imageLink) {
              imageUrls.push(choice.imageLink)
            }
          })
        }
      }

      // 画像アップロード
      if (type === 'file') {
        const uploadedFiles = surveyAnswer[name] as FileOption[] | undefined
        if (uploadedFiles) {
          uploadedFiles.forEach((file) => {
            if (file.content) {
              imageUrls.push(file.content)
            }
          })
        }
      }
    })
  } catch (error) {
    console.error('Failed to parse surveyConfigJson:', error)
    return []
  }

  return imageUrls
}
